// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /platform-webhooks/subscription-delete */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_DeleteResponseDados {
deleted: boolean
}

export type PlatformWebhooks_DeleteResponse = ApiResponse<PlatformWebhooks_DeleteResponseDados>;

registerResponseContract('PlatformWebhooks_DeleteResponse', {
  deleted: { type: 'boolean', required: true },
})
